var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6636 5.69824H28.4006L17.2542 38.7244C17.0196 39.4206 16.3671 39.8888 15.632 39.8888H7.27598C6.33192 39.8888 5.56641 39.1233 5.56641 38.1792C5.56641 37.9931 5.5968 37.8088 5.65568 37.6322L16.0414 6.8636C16.2759 6.16743 16.9284 5.69824 17.6636 5.69824Z",
    fill: "url(#paint0_linear_2217_4029)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2649 27.8506H16.2385C15.8035 27.8496 15.4502 28.203 15.4492 28.6379C15.4492 28.8573 15.5394 29.0663 15.7 29.2154L26.6412 39.4273C26.9594 39.7245 27.3792 39.8898 27.8151 39.8898H37.4562L33.2649 27.8506Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6616 5.69825C16.9179 5.69541 16.2597 6.17694 16.0356 6.88546L5.66702 37.6056C5.34884 38.4927 5.81043 39.4709 6.69751 39.7891C6.88366 39.8556 7.08026 39.8898 7.27876 39.8898H15.8513C16.501 39.7739 17.0385 39.317 17.2579 38.694L19.3256 32.6003L26.7109 39.489C27.0206 39.7454 27.409 39.8869 27.8108 39.8898H37.4167L33.2035 27.8505L20.9221 27.8534L28.4376 5.69825H17.6616Z",
    fill: "url(#paint1_linear_2217_4029)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3764 6.8617C31.1418 6.16648 30.4903 5.69824 29.7561 5.69824H17.7891C18.5223 5.69824 19.1748 6.16648 19.4084 6.86075L29.7941 37.6322C30.0961 38.5268 29.6155 39.4965 28.7208 39.7986C28.5451 39.8594 28.3609 39.8897 28.1747 39.8897H40.1418C41.0858 39.8897 41.8513 39.1242 41.8513 38.1792C41.8513 37.9931 41.8209 37.8088 41.7611 37.6331L31.3764 6.8617Z",
    fill: "url(#paint2_linear_2217_4029)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2217_4029",
    x1: 21.5772,
    y1: 8.23245,
    x2: 10.4264,
    y2: 41.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2217_4029",
    x1: 25.0582,
    y1: 23.583,
    x2: 22.479,
    y2: 24.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2217_4029",
    x1: 23.7199,
    y1: 7.24113,
    x2: 35.9599,
    y2: 39.8522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLogo);
export default __webpack_public_path__ + "static/media/Azure_Logo.14ac8c33088340901fbc4b85cfef897f.svg";
export { ForwardRef as ReactComponent };